import React from "react";
import { Container, Table, Row, Col } from "react-bootstrap";
import styles from "../ViewMarkForm/StudentView.module.css";
import "./StudentView.print.css";
import Moment from "react-moment";
import SectionHeading from "../SectionHeading/SectionHeading";
import MarkDistributionTable from "../MarkDistributionTable/MarkDistributionTable";
import { BASE_URL } from "../../constants/URL";
import logo from "../../Assets/logo.jpeg";

const StudentView = ({ data, response }) => {
  return (
    <Container fluid className="py-0">
      <div className="position-relative">
        {data?.student?.image ? (
          <>
            <img src={logo} alt="logo" className={styles.logo} />
            <div
              className={styles.logo2}
              style={{
                background: `url(${BASE_URL}/api/uploads/${data?.student?.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            ></div>
          </>
        ) : (
          <></>
        )}
        <SectionHeading
          noLogo={data?.student?.image}
          title={``}
          subtitle={``}
          grade={data?.student?.gradeId}
          shift={data?.student?.shiftId}
          batch={data?.student?.batchId}
        />
        {/* Print-friendly layout */}
        <div className="student-view-print">
          <div className="student-info-print">
            <Table bordered size="sm" responsive className="mb-0">
              <tbody>
                <tr>
                  {data && data.student && data.student.name && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Name</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.name}
                      </td>
                    </>
                  )}

                  {data && data.student && data.student.uid && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Serial</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.uid}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data &&
                    data.student &&
                    data.student.grade &&
                    data.student.grade.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Class</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.grade.name}
                        </td>
                      </>
                    )}

                  {data &&
                    data.student &&
                    data.student.shift &&
                    data.student.shift.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Shift</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.shift.name}
                        </td>
                      </>
                    )}
                </tr>
                <tr>
                  {data &&
                    data.student &&
                    data.student.batch &&
                    data.student.batch.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Batch</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.batch.name}
                        </td>
                      </>
                    )}

                  {data && data.student && data.student.phone && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Phone</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.phone}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.father && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Father</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.father}
                      </td>
                    </>
                  )}
                  {data && data.student && data.student.mother && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Mother</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.mother}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.dob && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Date of Birth</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <Moment format="DD/MM/YYYY">{data?.student.dob}</Moment>
                      </td>
                    </>
                  )}
                  {data && data.student && data.student.blood && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Blood Group</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.blood}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.address && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Address</span>
                      </td>
                      <td
                        colSpan={3}
                        className="py-1"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {data?.student.address}
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="mark-distribution-print">
            <MarkDistributionTable />
          </div>
        </div>

        {/* Fallback responsive layout for screen display */}
        <Row className="d-print-none">
          <Col md={8}>
            <Table bordered size="sm" responsive className="mb-0">
              <tbody>
                <tr>
                  {data && data.student && data.student.name && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Name</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.name}
                      </td>
                    </>
                  )}

                  {data && data.student && data.student.uid && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Roll</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.uid}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data &&
                    data.student &&
                    data.student.grade &&
                    data.student.grade.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Class</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.grade.name}
                        </td>
                      </>
                    )}

                  {data &&
                    data.student &&
                    data.student.shift &&
                    data.student.shift.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Shift</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.shift.name}
                        </td>
                      </>
                    )}
                </tr>
                <tr>
                  {data &&
                    data.student &&
                    data.student.batch &&
                    data.student.batch.name && (
                      <>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          <span className="fw-bold">Batch</span>
                        </td>
                        <td className="py-1" style={{ fontSize: "0.75rem" }}>
                          {data?.student.batch.name}
                        </td>
                      </>
                    )}

                  {data && data.student && data.student.phone && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Phone</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.phone}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.father && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Father</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.father}
                      </td>
                    </>
                  )}
                  {data && data.student && data.student.mother && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Mother</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.mother}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.dob && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Date of Birth</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <Moment format="DD/MM/YYYY">{data?.student.dob}</Moment>
                      </td>
                    </>
                  )}
                  {data && data.student && data.student.blood && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Blood Group</span>
                      </td>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        {data?.student.blood}
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  {data && data.student && data.student.address && (
                    <>
                      <td className="py-1" style={{ fontSize: "0.75rem" }}>
                        <span className="fw-bold">Address</span>
                      </td>
                      <td
                        colSpan={3}
                        className="py-1"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {data?.student.address}
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col md={4}>
            <MarkDistributionTable />
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default StudentView;
